import { useEffect, useState } from 'react';
import styled from 'styled-components';
import {
    Card,
    Typography,
} from "@mui/material";

import { useDashboardHook } from '../../Hooks/Dashboard/dashboardHooks';

import AccessibilityHelper from '../../Utilities/Helpers/AccessibilityHelper';

import { AdminModules } from '../../Utilities/Enums/AdminModulesEnum';

import CustomNoticeSnackbar from '../../CustomViews/Elements/CustomNoticeSnackbar';

import News from './News';

const DashboardContainer = styled(Card) <{ $darkMode?: boolean; }>`
    background: transparent !important;
    border: none;
    border-radius: 0px !important;
    display: grid;
    grid-template-columns: auto;
    gap: 30px;
    box-shadow: none !important;
    padding: 0px;
    overflow: visible !important;
`;

const NoticesContainer = styled(Card) <{ $darkMode?: boolean; }>`
    background: transparent !important;
    border: none;
    border-radius: 0px !important;
    display: grid;
    grid-template-columns: auto;
    gap: 15px;
    box-shadow: none !important;
    padding: 0px;
    max-height: 20vh;
    overflow-x: hidden !important;
    overflow-y: auto !important;
`;

export default function Dashboard() {
    const { data, fetchStatus } = useDashboardHook();

    //Use States
    let [notices, setnotices] = useState<any>([]);

    //Event Handlers
    const initializeData = async (_notices: any) => {
        setnotices(_notices);
    }
    useEffect(() => {
        if(fetchStatus != "fetching") {
            initializeData(data?.data ?? []);
        }
    }, [fetchStatus, data]);

    //Rendering Functions
    return <DashboardContainer>
        <NoticesContainer>
            {notices?.map((notice: any, noticeIndex: number) => (<>
                <CustomNoticeSnackbar
                    label={notice?.message ?? "--"}
                    warningType={notice?.warningType ?? 1}
                    onRemove={() => {
                        setnotices(notices?.filter((item: any, index: number) => index != noticeIndex));
                    }} />
            </>))}
        </NoticesContainer>
        {AccessibilityHelper.hasAccess(AdminModules.NEWS_VIEW) && <News />}
    </DashboardContainer>
}
